// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery-img img{width:100%;height:100%;aspect-ratio:1/1}.gallery-img-size,.gallery-img-size img{height:calc(100vh - 200px);width:calc(100vw - 200px)}@media(min-width:1200px){.gallery-img-size,.gallery-img-size img{width:calc(100vw - 400px)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
